export default __webpack_public_path__ + "static/media/risk_level_4.0405ccaf.png";